import React, { useEffect, useState } from 'react';
import LayoutComp from 'components/LayoutComp/Index';
import { useDispatch } from 'react-redux';
import { STATIC_TEXT } from 'utils/constants';
import './styles.scss';
import { Button, Col, Row } from 'antd';
import { SurveyInsight, SurveyVault } from 'assets';
import Navigation from 'components/Navigation';

import { fetchCategories } from 'containers/QuestionCategory/category.action';
// import Loader from 'components/ui/Loader';

const Dashbord = (props) => {
  const { history } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCategories());

    // eslint-disable-next-line
  }, [dispatch]);
  const [currentSelect, setCurrentSelect] = useState(1);
  const handleNext = () => {
    if (currentSelect == 1) {
      history.push('/question_category');
    } else {
      history.push('/insight');
    }
  };
  return (
    <div className="Dashboard">
      <LayoutComp history={history}>
        <div id="surveyType">
          <div className="back-nav">{STATIC_TEXT['SELECT_OPTION']}</div>
          <p className="sub-heading">{STATIC_TEXT['SELECT_OPTION_TO_DOWNLOAD_YOUR_SURVEY']}</p>
          <Row style={{ marginBottom: '15vh' }}>
            <Col span={11}>
              <div
                className={`box-shadow dashboard ${currentSelect == 1 && 'active'}`}
                onClick={() => setCurrentSelect(1)}
              >
                <div className="box-image">
                  <img src={SurveyVault} alt="images" />
                </div>
                <div className="box-content">
                  <div>
                    <p style={{ color: '#858585' }}>
                      {STATIC_TEXT.SELECT_OPTION_TO_CONTINUE_WITH_THE_SURVEY}
                    </p>
                    <Button
                      type={currentSelect === 1 ? 'primary' : ''}
                      onClick={() => setCurrentSelect(1)}
                    >
                      {STATIC_TEXT.HFS_SURVEY_VAULT}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
            <Col span={11} offset={2}>
              <div
                className={`box-shadow dashboard ${currentSelect == 2 && 'active'}`}
                onClick={() => setCurrentSelect(2)}
              >
                <div className="box-image">
                  <img src={SurveyInsight} alt="images" />
                </div>

                <div className="box-content">
                  <div>
                    <p style={{ color: '#858585' }}>
                      {STATIC_TEXT.SELECT_OPTION_TO_CONTINUE_WITH_THE_SURVEY}
                    </p>
                    <Button type={currentSelect === 2 ? 'primary' : ''}>
                      {STATIC_TEXT.HFS_SURVEY_INSIGHTS}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Navigation handleNext={handleNext} />
        </div>
      </LayoutComp>
    </div>
  );
};

export default Dashbord;
